<edit-dialog-custom (action)="signalAction($event)" [title]="title" [document]="shipToEdit" [structureName]="structureName()" [structure]="rowDataDefault()" [templateCount]="0" class="flex flex-col">
  <ng-container edit-body></ng-container>
</edit-dialog-custom>
